<template>
    <div style="width: 50%;text-align: center;margin-left: 30%;margin-top: 10%;">
        <Form ref="formValidate" :model="formValidate" :rules="ruleInline" :label-width="100">
            <FormItem label="账号:" prop="userName">
                <Input type="text" v-model="formValidate.userName" disabled></Input>
            </FormItem>
            <FormItem label="影院名称:" prop="company">
                <Input type="text" v-model="formValidate.company" placeholder="请输入影院名称"></Input>
            </FormItem>
          <FormItem label="联系人:" prop="nikeName">
            <Input type="text" v-model="formValidate.nikeName" placeholder="请输入联系人"></Input>
          </FormItem>
          <FormItem label="手机号:" prop="phoneNumber">
            <Input type="text" v-model="formValidate.phoneNumber" placeholder="请输入手机号"></Input>
          </FormItem>
<!--          <FormItem label="地址:" prop="address">
            <Input type="text" v-model="formValidate.address" placeholder="请输入地址"></Input>
          </FormItem>-->
            <FormItem label="原始密码:" prop="password">
                <Input type="password" v-model="formValidate.password" placeholder="请输入原始密码"></Input>
            </FormItem>
            <FormItem label="新密码:" prop="newPassword">
                <Input type="password" v-model="formValidate.newPassword" placeholder="请输入新密码"></Input>
            </FormItem>
            <FormItem label="确认新密码:" prop="newConfirmPassword">
                <Input type="password" v-model="formValidate.newConfirmPassword" placeholder="请输入新密码"></Input>
            </FormItem>
            <FormItem>
                <Button @click="handle" style="margin-left: 8px">取消</Button>
                <Button type="primary" @click.native="handleReset" style="margin-left: 8px">修改</Button>
            </FormItem>
        </Form>
    </div>
</template>

<script>
    import {
        updatePassword,
        getInfo
    } from "@/request/api.js";

    export default {
        name: "UpdatePassword",
        data() {
            return {
                formValidate: {
                    userName: '',
                    nikeName: '',
                    company: '',
                    phoneNumber: '',
                    address: '',
                    password: '',
                    newPassword: '',
                    newConfirmPassword: '',
                    userId: window.sessionStorage.getItem('userId'),
                },
                ruleInline: {
                    userName: [{
                        required: true,
                        message: '请输入账号',
                        trigger: 'blur'
                    }],
                  company: [{
                    required: true,
                    message: '请输入影院名称',
                    trigger: 'blur'
                  }],
                  // phoneNumber: [{
                  //   required: true,
                  //   message: '请输入手机号',
                  //   trigger: 'blur'
                  // }],
                  nikeName: [{
                    required: true,
                    message: '请输入联系人',
                    trigger: 'blur'
                  }],
                    password: [{
                        required: true,
                        message: '请输入原始密码',
                        trigger: 'blur'
                    }],
                    newPassword: [{
                        required: true,
                        message: '请输入新密码',
                        trigger: 'blur'
                    }],
                    newConfirmPassword: [{
                        required: true,
                        message: '请再次输入新密码',
                        trigger: 'blur'
                    }]
                }
            }
        },
        methods: {
            handle() {
                this.$router.history.push('/index')
            },
            handleReset() {
                if (this.formValidate.newPassword != this.formValidate.newConfirmPassword) {
                    this.$Message['error']({
                        background: true,
                        content: '两次输入密码不一致！'
                    });
                } else {
                  // var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                  // const reg_tel = /^1(3\d|4[5-9]|5[0-3,5-9]|6[2-5]|7[0-8]|8\d|9[1,3,5-9])\d{8}$/;
                  // const reg_tel = /^1[3-9]\d{9}$/;
                  // if(reg_tel.test(this.formValidate.phoneNumber)) {
                    let formData = this.formValidate;
                    updatePassword(formData).then(res => {
                      this.$Message.error(res.msg);
                      if (res.code == 20000) {
                        this.$router.history.push('/login')
                      }
                    });
                  // }else{
                  //   this.$Message.error("请输入正确的手机号！");
                  // }
                }
            }
        },
      created() {
        getInfo(window.sessionStorage.getItem("token")).then((res) => {
          if(res.code==20000){
              this.formValidate = res.data
          }
        })
      }
      }


</script>

<style>
</style>
